import React, { useEffect, useRef, useState } from "react";
import {
  BiMailSend,
  BiTrashAlt,
  BiRefresh,
  BiMobileVibration,
  BiCheck,
  BiPlusCircle,
  BiXCircle,
} from "react-icons/bi";

import ReactTooltip from "react-tooltip";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Alert,
  Card,
  Input,
  ModalBody,
  ModalHeader,
  Modal,
  Badge,
} from "reactstrap";
import SlackSharePopup from "../../../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../../../components/SlackAndTeamsPopups/TeamsSharePopup";
import {
  baseUrl,
  formatPhoneNumber,
  OVERTIME_TEXT,
  profilePicValidityCheck,
  TRIVIA_DESCRIPTION,
  TRIVVY_SLACK_MEMEBER_MESSAGE,
} from "../../../../utils/constants";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { toastContainer } from "../../../../utils/toast";
import Select from "react-select/lib/Select";
import {
  isPublishedDateGreaterThanGivenDate,
  TRIVIA_SHARE_PRIVACY_OPTIONS,
  TRIVIA_USER_IDENTIFICATION_OPTIONS,
} from "../../data";
import CheckBox from "rc-checkbox";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import {
  ActionLayoutData,
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../../weekly-wins/TableLayoutComponents";
import { isMobile } from "../../../../utils/deviceInfo";
import { MdOutlineMobileFriendly, MdUpload } from "react-icons/md";
import SendSmsTextQuestionsModal from "./SendSmsTextQuestionsModal";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
import { PiPaperPlaneRightFill } from "react-icons/pi";
import "./sharepage.css";
import { FaLinkedin, FaSlack, FaWhatsapp } from "react-icons/fa";
import PhoneInputWithCountrySelect from "react-phone-number-input";

export default function NewShareTriviaComponent({
  user,
  surveyId,
  setCurrentQuestion,
  survey,
  editCurrentTriviaShareData,
  callApiToAutoSave,
  setCurrentTrivia,
  publishTriviaApiCall,
  ...props
}) {
  const isOwner = false;
  const shareUrl = `${baseUrl()}home/trivia/${
    user.profile.organizationId._id
  }/quiz/${surveyId}/start`;
  const copySurveyUrl = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
    window.navigator.clipboard.writeText(`${shareUrl}?medium=copy`);
  };

  const [allowSendLimitSMS, setAllowSendLimitSMS] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [newUserRows, setNewUserRows] = useState([
    { name: "", mobileNumber: "" },
  ]);
  const [options, setOptions] = useState([]);
  const newUser = newUserRows[0];
  const innerRef = useRef();
  const innerRef2 = useRef();

  const handleNewUserRowChange = (value, key, index) => {
    const rows = [...newUserRows];
    rows[index][key] = value;
    setNewUserRows(rows);
  };

  const isNewUser = (usr) => {
    const usersAll = [...usersListAll];
    if (usr.email || usr.mobileNumber) {
      const user = usersAll.find(
        (x) =>
          usr._id ||
          (usr.email &&
            x.email &&
            usr.email.trim().toLowerCase() === x.email.trim().toLowerCase()) ||
          (usr.mobileNumber &&
            x.mobileNumber &&
            usr.mobileNumber.trim() === x.mobileNumber.trim())
      );

      if (user) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const handleInputChange = (value) => {
    // Filter options based on input value
    const filteredOptions = originalOptions.filter((option) =>
      option.label.toLowerCase().includes(value.toLowerCase())
    );
    if (filteredOptions.length == 0) {
      if (isNaN(value)) {
        setNewUserRows([{ ...newUserRows[0], name: value }]);
      } else {
        setNewUserRows([{ ...newUserRows[0], mobileNumber: value }]);
      }
    }
    setOptions(filteredOptions);
  };

  const [smsUsers, setSmsUsers] = useState(0);

  const [emailSmsSendModal, setEmailSmsSendModal] = useState({
    open: false,
    type: "",
  });

  const [isCopied, setIsCopied] = useState(false);

  const [sendSmsTextModal, setSendSmsTextModal] = useState(false);

  const [showShareconfirm, setShowShareConfirm] = useState({
    display: false,
    emails: 0,
    sms: 0,
  });

  const [showLimitSMSAlert, setShowLimitSMSAlert] = useState({
    display: false,
    totalSMS: 0,
    remainingLimit: 0,
  });

  const downloadQRCode = () => {
    const canvas = document.querySelector("#qrcode-canvas");
    if (!canvas) throw new Error("<canvas> not found in the DOM");

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "QR code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const refreshTableUsersForMobileNumber = () => {
    const usersOriginal = [...usersListAll];
    const tableUsersRefresh = triviaShareAndPrivacy.sharedWithUsers.map(
      (user) => {
        const findUser = usersOriginal.find(
          (x) => x._id && user.value && x._id.toString() == user.value.toString()
        );
        if (findUser) {
          return {
            ...user,
            mobileNumber: findUser.mobileNumber,
          };
        } else {
          return {
            ...user,
          };
        }
      }
    );

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: tableUsersRefresh,
    });
  };

  const copyQRCode = () => {
    const canvas = document.querySelector("#qrcode-canvas");
    if (!canvas) throw new Error("<canvas> not found in the DOM");

    const ctx = canvas.getContext("2d");
    ctx.fillRect(100, 100, 100, 100);
    ctx.fillStyle = "#eee";
    ctx.fillRect(100, 100, 100, 100);

    //tested on chrome 76
    canvas.toBlob(function(blob) {
      const { ClipboardItem } = window;
      const item = new ClipboardItem({ "image/png": blob });
      navigator.clipboard.write([item]);
    });
  };

  const [allUsersChecked, setAllUsersChecked] = useState(false);
  const [shareTrivvyViaEmail, setShareTrivvyViaEmail] = useState(false);
  const [shareTrivvyViaSMS, setShareTrivvyViaSMS] = useState(false);
  const [shareSlackopen, setShareSlackOpen] = useState(false);
  const [shareTeamsopen, setShareTeamsOpen] = useState(false);
  const [triviaShareAndPrivacy, setTriviaShareAndPrivacy] = useState({
    sharedWithUsers: [],
    privacy: survey.privacy,
  });
  const [userIdentification, setUserIdentification] = useState(
    survey.userIdentificationOptions && survey.userIdentificationOptions[0]
  );

  const [usersListAll, setUsersListAll] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [permissionPopoverOpen, setPermissionPopoverOpen] = useState(false);
  const [duplicateusers, setDuplicateusers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [view, setView] = useState(isMobile ? "MOBILE" : "DESKTOP");
  const [newSelectedUser, setNewSelectedUser] = useState(null);
  const originalOptions = usersList.filter(
    (x) =>
      !triviaShareAndPrivacy.sharedWithUsers.some((y) => y.value == x.value)
  );

  const togglePermission = () => {
    setPermissionPopoverOpen(!permissionPopoverOpen);
  };

  const revertOptions = () => {
    setOptions(originalOptions);
    //  getUserList(formatSelectedUsers(survey.sharedWithUsers))
    setUsersList(formatSelectedUsers(usersListAll));
    // console.log(formatSelectedUsers(usersListAll), '<<>> usersListAll')
    setNewUserRows([{ name: "", mobileNumber: "" }]);
  };

  useEffect(() => {
    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
    });

    getUserList(formatSelectedUsers(survey.sharedWithUsers));

    // const onlySMSUsers = [
    //   ...formatSelectedUsers(survey.sharedWithUsers),
    // ].filter((x) => x.mobileNumber && x.mobileNumber.length > 0);
    // console.log("loop_loop", { onlySMSUsers });
    // setUsersList(onlySMSUsers);
    // setSmsUsers(onlySMSUsers.length);

    if (survey.privacy == "ENTERPRISE") {
      setAllUsersChecked(true);
    }
  }, []);

  const onUserSelect = (u) => {
    setNewSelectedUser(u);
    // const list = [...usersList].filter((x) => x.value != u.value);
    // setUsersList(list);

    if (u && u.mobileNumber && u.mobileNumber.length > 0) {
      let userCellCount = smsUsers + 1;
      setSmsUsers(userCellCount);
    }

    const array = [u, ...triviaShareAndPrivacy.sharedWithUsers];
    if (u) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: array,
      });
    }
  };

  const removeUser = (id, mobileNumber) => {
    const users = [...triviaShareAndPrivacy.sharedWithUsers];

    const newUsers = users.filter((x) => x.value != id);
    if (mobileNumber && mobileNumber.length > 0) {
      console.log("remove mobile number count -----", smsUsers);
      let userCellCount = smsUsers == 0 ? 0 : smsUsers - 1;
      console.log("after removed -----", userCellCount);

      setSmsUsers(userCellCount);
    }

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: [...newUsers],
    });

    // callApiToSaveData(newUsers, "REMOVE");
  };

  const removeDuplicatesUsersByEmailAndMobileNumber = (arr) => {
    const emails = new Set();
    const phoneNumbers = new Set();
    const duplicatesArray = [];

    console.log("new-arr", arr, arr.length);

    const filtered = arr.filter((item) => {
      const { email, mobileNumber } = item;
      if (
        (email && emails.has(email)) ||
        (mobileNumber && phoneNumbers.has(mobileNumber))
      ) {
        console.log(
          "DUPP",
          { email, mobileNumber, emails, phoneNumbers },
          email && emails.has(email),
          mobileNumber && phoneNumbers.has(mobileNumber)
        );
        duplicatesArray.push(item);
        return false; // exclude duplicates (either email or phoneNumber is already seen)
      } else {
        console.log(
          "NO_DUPP",
          { email, mobileNumber, emails, phoneNumbers },
          email && emails.has(email),
          mobileNumber && phoneNumbers.has(mobileNumber)
        );
        if (email) {
          emails.add(email); // add email to the Set
        }
        if (mobileNumber) {
          phoneNumbers.add(mobileNumber); // add phoneNumber to the Set
        }

        return true; // include unique item
      }
    });

    setDuplicateusers(duplicatesArray);
    emails.clear();
    phoneNumbers.clear();
    return filtered;
  };

  const onUserSelectAll = (u) => {
    if (u) {
      const onlySMSUsers = [...usersList].filter(
        (x) => x.mobileNumber && x.mobileNumber.length > 0
      );
      setSmsUsers(onlySMSUsers.length);
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: usersList,
      });
    } else {
      setSmsUsers(0);
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [],
      });
    }
  };

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
          shareMediums: e.shareMediums,
          emailDate: e.emailDate,
          smsDate: e.smsDate,
          isSubmitted: e.isSubmitted,
        };
      } else if (e) {
        let name =
          e.firstName && e.firstName.length > 0
            ? e.firstName
            : e.lastName && e.lastName.length > 0
            ? e.lastName
            : e.email;
        return {
          label: `${name}`,
          value: e._id || e.userId,
          permissions: 0,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
          shareMediums: e.shareMediums,
          emailDate: e.emailDate,
          smsDate: e.smsDate,
          isSubmitted: e.isSubmitted,
        };
      }
    });

    return d;
  };

  const getUserList = (sharedWithUsers) => {
    setUsersLoading(true);
    axios
      .get(url.userListArray + "?includeMe=true")
      .then((response) => {
        setUsersLoading(false);
        let arr = [...response.data.data];

        setUsersListAll([...response.data.data]);

        if (sharedWithUsers && sharedWithUsers.length > 0) {
          let isCurrentUserNotinShared = !sharedWithUsers.some(
            (obj) => obj.value == user.profile._id
          );

          if (isCurrentUserNotinShared) {
            arr = [...response.data.data];
          }
        } else {
          arr = [...response.data.data];
        }
        // const arr = [user.profile, ...response.data.data];
        setUsersData(arr);

        const users = formatSelectedUsers(arr);

        const onlySMSUsers = [...sharedWithUsers].filter(
          (x) => x.mobileNumber && x.mobileNumber.length > 0
        );

        setSmsUsers(onlySMSUsers.length);

        if (privacy == "ENTERPRISE") {
          setTriviaShareAndPrivacy({
            ...triviaShareAndPrivacy,
            privacy: "CUSTOM",
            sharedWithUsers: users,
          });
        }

        if (survey) {
          setUsersList(users);
        } else {
          setUsersList(users);
        }
        setOptions(users);
      })
      .catch((error) => {
        setUsersLoading(false);
        console.log(error);
      })
      .finally(() => {
        setUsersLoading(false);
      });
  };

  const handleSocialShare = async (data) => {
    return new Promise((resolve, reject) => {
      const text = `Attend Quiz here - ${survey.name} : ${shareUrl}?medium=slack`;
      let payload = {
        storyText: text,
        attachmentsText: "",
        user: {
          username: data.isAnonymous
            ? "Anonymous"
            : `${user.profile.firstName} ${user.profile.lastName}`,
          text: "",
        },
        entityType: "QUIZ",
        channelId: data.channelId,
        channelName: data.channelName,
        type: data.type,
        workSpaceId: data.workSpaceId,
        teamId: data.teamId,
        tenantId: data.tenantId,
      };

      axios
        .post(url.shareStoryPost, payload)
        .then(({ data }) => {
          // console.log("data shared----", data);
          toastContainer("Shared successfully", "success");
          console.log("resolving", data.channelId);
          resolve(payload.channelId);
        })
        .catch((error) => {
          let message = "Error occured while sending message";
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message
          ) {
            message = TRIVVY_SLACK_MEMEBER_MESSAGE;
          }
          toastContainer(message, "error");
          reject(message);
        });
    });
  };

  const usersChanged = () => {
    if (triviaShareAndPrivacy && survey) {
      const eqSet = (xs, ys) =>
        xs.size === ys.size && [...xs].every((x) => ys.has(x));

      const surveyUsers = survey.sharedWithUsers.map((x) => ({
        id: x.userId && x.userId.toString(),
        mobileNumber: x.mobileNumber,
        smsDate:"",
        emailDate:"",
        date:""
      }));
      const privStateUsers = triviaShareAndPrivacy.sharedWithUsers.map((x) => ({
        id: x.value && x.value.toString(),
        mobileNumber: x.mobileNumber,
        smsDate:"",
        emailDate:"",
        date:""
      }));

      if (JSON.stringify(surveyUsers) == JSON.stringify(privStateUsers)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const showNoChangeAlert = () => {
    // console.log(!usersChanged() , triviaShareAndPrivacy.privacy == survey.privacy , shareTrivvyViaEmail == survey.shareTrivvyViaEmail , shareTrivvyViaSMS === survey.shareTrivvyViaSMS)

    if (
      survey &&
      !usersChanged() &&
      triviaShareAndPrivacy.privacy == survey.privacy &&
      shareTrivvyViaEmail == survey.shareTrivvyViaEmail &&
      shareTrivvyViaSMS === survey.shareTrivvyViaSMS &&
      userIdentification === survey.userIdentificationOptions[0]
    ) {
      let flag = true;
      for (const user of triviaShareAndPrivacy.sharedWithUsers) {
        if (user.shareMediums && user.shareMediums.length == 0) {
          flag = false;
        }

        if (
          isPublishedDateGreaterThanGivenDate(user.emailDate, survey) ||
          isPublishedDateGreaterThanGivenDate(user.smsDate, survey)
        ) {
          flag = false;
        }
      }
      return flag;
    } else {
      return false;
    }
  };

  const saveTrivvyShareUsersApi = () => {
    console.log(triviaShareAndPrivacy, "<<>> triviaShareAndPrivacy");
    let users_share = triviaShareAndPrivacy.sharedWithUsers.map((itm) => {
      const user = usersListAll.find((x) => x._id == itm.value);

      let sendToUsersAgain = false;
      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length ? itm.shareMediums : [],
          emailDate: itm.emailDate ? itm.emailDate : null,
          smsDate: itm.smsDate ? itm.smsDate : null,
        };
      } else {
        if(isNewUser(itm)){
          
          return {
            firstName: itm.firstName,
            lastName: itm.lastName,
         
            date: new Date(),
          
            email: itm.email,
            mobileNumber: itm.mobileNumber,
            shareMediums:[]
          
          }
        }
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
          date: itm.date ? itm.date : new Date(),
          shareMediums: ["EMAIL"],
        };
      }
    });

    axios
      .post(url.saveTrivvyShareUsersApi(survey._id), {
        sharedWithUsers: users_share,
        privacy: triviaShareAndPrivacy.privacy,
        shareTrivvyViaEmail,
        shareTrivvyViaSMS,
      })
      .then(({ data }) => {
        toastContainer("Users saved succesfully!", "success");
        const survey = data.data;

        getUserList(survey.sharedWithUsers)

        console.log("pppppp",...survey.sharedWithUsers,formatSelectedUsers(survey.sharedWithUsers))
        editCurrentTriviaShareData({
          privacy: survey.privacy,
          sharedWithUsers: [...survey.sharedWithUsers],
        });
        setTriviaShareAndPrivacy({
          ...triviaShareAndPrivacy,
          sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
        });
      })
      .catch((err) => {
        toastContainer("Error while saving users data", "error");
      });
  };

  const callApiToSaveData = (array = [], type = "SENT") => {
    let users_share = array.map((itm) => {
      const user = usersListAll.find((x) => x._id == itm.value);

      let sendToUsersAgain = false;
      if (user) {
        const mediums = itm.shareMediums || [];

        if (
          user.mobileNumber &&
          shareTrivvyViaSMS &&
          !mediums.includes("SMS")
        ) {
          mediums.push("SMS");
        }

        if (shareTrivvyViaEmail && !mediums.includes("EMAIL")) {
          mediums.push("EMAIL");
        }

        const updateSMSDate = isPublishedDateGreaterThanGivenDate(
          itm.smsDate,
          survey
        );
        const updateEmailDate = isPublishedDateGreaterThanGivenDate(
          itm.emailDate,
          survey
        );
        const updateDate = isPublishedDateGreaterThanGivenDate(
          itm.date,
          survey
        );
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length > mediums.length
              ? itm.shareMediums
              : mediums,
          emailDate: shareTrivvyViaEmail ? itm.emailDate ? itm.emailDate : new Date() :itm.emailDate?itm.emailDate:null,
          smsDate: shareTrivvyViaSMS ? itm.smsDate ? itm.smsDate : new Date():itm.smsDate?itm.smsDate:null,
          updateSMSDate,
          updateEmailDate,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
          date: itm.date ? itm.date : new Date(),
          shareMediums: ["EMAIL"],
        };
      }
    });

    const orgObject = user.profile.organizationId;

    const remainingSMS = orgObject.smsLimit - orgObject.totalSmsSent;

    const users_share_sms = users_share.filter((x) =>
      x.shareMediums.includes("SMS")
    );

    if (remainingSMS < users_share_sms.length) {
      let smsCountInc = 0;
      users_share = users_share.map((x, idx) => {
        if (smsCountInc < remainingSMS) {
          if (x.shareMediums.includes("SMS")) {
            smsCountInc += 1;
          }
          return x;
        } else {
          x.shareMediums = ["EMAIL"];
          return x;
        }
      });
    }

    if (remainingSMS < users_share_sms.length && !allowSendLimitSMS) {
      setShowLimitSMSAlert({
        display: true,
        totalSMS: users_share_sms.length,
        remainingLimit: remainingSMS,
      });
      return;
    }

    if (survey) {
      axios
        .put(url.sendTrivvyToSharedUsers(survey._id), {
          privacy: triviaShareAndPrivacy.privacy,
          sharedWithUsers: users_share,
          shareTrivvyViaSMS,
          shareTrivvyViaEmail,
        })
        .then((res) => {
          setAllowSendLimitSMS(false);
          setShowLimitSMSAlert({
            display: false,
            remainingLimit: 0,
            totalSMS: 0,
          });
          const survey = res.data.data && res.data.data;

          const emailsSent = survey.emailsSentCount;
          const smsSent = survey.smsSentCount;

          if (type == "SENT") {
            if (smsSent) {
              if (props.orgChangeSuccess) {
                props.orgChangeSuccess({
                  totalSmsSent:
                    user.profile.organizationId.totalSmsSent + smsSent,
                });
              }
            }
            if (emailsSent || smsSent) {
              toastContainer(
                `Congrats! Your trivvy was sent.${
                  emailsSent > 0 ? ` Emails sent - ${emailsSent}` : ""
                }${emailsSent > 0 && smsSent > 0 ? ", " : " "}${
                  smsSent > 0 ? `SMS sent - ${smsSent}` : ""
                }`,
                "success"
              );
            } else {
              toastContainer(`Your Changes were Saved.`, "success");
            }
          } else if (type == "REMOVE") {
            toastContainer("Your Changes were Saved.", "success");
          }

          setNewSelectedUser(null);

          if (survey) {
            editCurrentTriviaShareData({
              privacy: survey.privacy,
              sharedWithUsers: [...survey.sharedWithUsers],
              shareTrivvyViaEmail: survey.shareTrivvyViaEmail,
              shareTrivvyViaSMS: survey.shareTrivvyViaSMS,
              firstPublishedDate: survey.firstPublishedDate,
            });
            setTriviaShareAndPrivacy({
              ...triviaShareAndPrivacy,
              sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
            });
          }
        })
        .catch((error) => {
          setShowLimitSMSAlert({
            display: false,
            remainingLimit: 0,
            totalSMS: 0,
          });
          setNewSelectedUser(null);
          setAllowSendLimitSMS(false);
          const message =
            error.response && error.response.data && error.response.data.errors
              ? error.response.data.errors.message
              : "Error occured while sharing.";

          toastContainer(message, "error");
          setTriviaShareAndPrivacy({
            privacy: survey.privacy,
            sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
          });
          console.log(error);
        });
    }
  };

  const { privacy, sharedWithUsers } = triviaShareAndPrivacy;

  const [isEndDateBeforeToday, setIsEndDateBeforeToday] = useState(false);

  let isSharable = survey.isPublished;

  if (isEndDateBeforeToday) {
    isSharable = false;
  }

  let adminRestricted = false;

  if (survey && survey.createdBy && user && user.profile) {
    if (survey && survey.createdBy._id != user.profile._id) {
      adminRestricted = true;
    }

    if (user.profile.orgAdmin || user.profile.role == "Admin") {
      adminRestricted = false;
    }
  }

  useEffect(() => {
    if (survey) {
      if (moment(survey.trivvyEndDate).isBefore(moment().startOf("day"))) {
        setIsEndDateBeforeToday(true);
      }
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
      });
    }
  }, [survey]);

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const viewMember = (u) => {
    let link = `/home/${user.profile.organizationId._id}/profile/${u.value}`;
    props.history.push(link);
  };

  const tableCols = {
    user: 3,
    date: 2,
    action: 2,
    phoneNumber: shareTrivvyViaSMS ? 3 : 0,
    email: shareTrivvyViaEmail ? 3 : 0,
    sharedVia: 2,
  };

  const planInvalid =
    user.profile && user.profile.organizationId
      ? ["001", "002"].includes(user.profile.organizationId.trivvyPlanType)
      : false;

  const planInvalidSms =
    user.profile && user.profile.organizationId
      ? ["001"].includes(user.profile.organizationId.trivvyPlanType)
      : false;

  const shareMediumDisabled = () => {
    if (survey) {
      if (triviaShareAndPrivacy.privacy == "PUBLIC") {
        return false;
      } else {
        if (triviaShareAndPrivacy.privacy == "CUSTOM") {
          return false;
        }
        if (survey.privacy != triviaShareAndPrivacy.privacy) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  };

  const handleClickShareButton = (shareConfirmed) => {
    if (shareConfirmed) {
      callApiToSaveData(triviaShareAndPrivacy.sharedWithUsers, "SENT");
    } else {
      let emailsCounts = 0;
      let smsCounts = 0;

      if (shareTrivvyViaEmail) {
        for (const user of triviaShareAndPrivacy.sharedWithUsers) {
          if (user.shareMediums && user.shareMediums.includes("EMAIL")) {
            if (
              user.emailDate &&
              isPublishedDateGreaterThanGivenDate(user.emailDate, survey) &&
              !user.isSubmitted
            ) {
              emailsCounts += 1;
            }
          } else {
            emailsCounts += 1;
          }
        }
      }

      if (shareTrivvyViaSMS) {
        for (const user of triviaShareAndPrivacy.sharedWithUsers) {
          if (user.shareMediums && user.shareMediums.includes("SMS")) {
            if (
              user.smsDate &&
              isPublishedDateGreaterThanGivenDate(user.smsDate, survey) &&
              !user.isSubmitted
            ) {
              smsCounts += 1;
            }
          } else {
            if (user.mobileNumber) {
              smsCounts += 1;
            }
          }
        }
      }
      setShowShareConfirm({
        display: true,
        emails: emailsCounts,
        sms: smsCounts,
      });
    }
  };

  const saveSharedConfig = () => {
    console.log("sharedConigbtn");
    if (usersChanged()) {
      console.log("changed users");
      return false;
    } else if (triviaShareAndPrivacy.privacy != survey.privacy) {
      console.log("810--privacy",triviaShareAndPrivacy.privacy , survey.privacy);
      return false;
    }
    return true;
  };
  {
    /* !usersChanged() || planInvalidSms ||(triviaShareAndPrivacy.privacy == survey.privacy) */
  }

  useEffect(() => {
    if (allowSendLimitSMS == true) {
      callApiToSaveData(triviaShareAndPrivacy.sharedWithUsers, "SENT");
    }
  }, [allowSendLimitSMS]);

  const getOptions = async (inputValue, callback) => {
    if (inputValue) {
      return axios
        .post(`${url.userListArrayForTrivvyShare}`, {
          triviaId: surveyId,
          text: inputValue,
        })
        .then(({ data }) => {
          const searchedList = formatSelectedUsers(data.data);
          const usersSearched = searchedList.filter(
            (x) => !sharedWithUsers.some((y) => y.value == x.value)
          );

          setUsersList(usersSearched);

          if (usersSearched.length == 0) {
            if (isNaN(inputValue)) {
              setNewUserRows([{ ...newUserRows[0], name: inputValue }]);
            } else {
              setNewUserRows([{ ...newUserRows[0], mobileNumber: inputValue }]);
            }
          }
          return {
            options: shareTrivvyViaSMS
              ? usersSearched.filter((x) => x.mobileNumber)
              : usersSearched,
            // options: usersSearched,
          };
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      return {
        // options: usersList,
        options: shareTrivvyViaSMS
          ? usersList.filter((x) => x.mobileNumber)
          : usersList,
      };
    }
  };

  console.log(triviaShareAndPrivacy.privacy, "---- privacy --- ", privacy);
  console.log("survey pri --- ", survey);
  console.log(
    "is privacy equal : ",
    triviaShareAndPrivacy.privacy != survey.privacy
  );
  const addNewRowUserToShareTable = (index) => {
    const newUsersArr = [...newUserRows];

    const newUserObject = newUsersArr[0];

    if(shareTrivvyViaEmail && newUserObject.email){
      const userExists = usersListAll.find(x => x.email == newUserObject.email.toLowerCase());
      if(userExists){
        toastContainer("User already exists","error")
      }
    }
    if(shareTrivvyViaSMS && newUserObject.mobileNumber){
      const userExists = usersListAll.find(x => x.mobileNumber == newUserObject.mobileNumber);
      if(userExists){
        toastContainer("User already exists","error")
      }
    }

    const sharedUsers = [];

    const formatObject = {
      ...(newUserObject.name && {
        firstName: newUserObject.name.split(" ")[0],
        lastName: newUserObject.name.split(" ")[1],
      }),
      mobileNumber: newUserObject.mobileNumber,
      email:newUserObject.email
    };

    sharedUsers.push(formatObject);

    console.log(
      {
        ...triviaShareAndPrivacy,
        sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber([
          ...triviaShareAndPrivacy.sharedWithUsers,
          ...sharedUsers,
        ]),
      },
      "<<>> sharedandprivacy"
    );

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber([
        ...triviaShareAndPrivacy.sharedWithUsers,
        ...sharedUsers,
      ]),
    });

    revertOptions();
  };

  const tableUI = (
    <div>
      <div className={`mt-4 share-trivia-invite-wrapper`}>
        <div className="dFelxCenterWithGap justify-content-between">
          {" "}
          <h5>Invite Users</h5>{" "}
          <div>
            <span
              className="cursor-pointer"
              onClick={() => {
                refreshTableUsersForMobileNumber();
              }}
            >
              {" "}
              <BiRefresh /> Refresh{" "}
            </span>{" "}
            <span>
              {" "}
              <OoPopover
                target="refresh_users_section_popover"
                headerText="Refresh users"
                bodyText={
                  "Click to update users with their latest data like Mobile Number."
                }
              />{" "}
            </span>
          </div>
        </div>

        <div className={`my-1 share-quiz-privacy`}>
          <FormGroup
            className={
              isOwner
                ? "disabled-change-permission mt40 share-quiz-privacy-form-css"
                : "mt40 share-quiz-privacy-form-css"
            }
            row
          >
            <Col sm={12} md={12} lg={12}>
              <span
                className="enterprise-setting-label"
                style={{
                  fontSize: "14px",
                }}
              >
                {allUsersChecked ? "Deselect to remove" : "Select to add"} all
                users{" "}
              </span>
              <CheckBox
                disabled={planInvalidSms}
                checked={allUsersChecked}
                onChange={(e) => {
                  setAllUsersChecked(!allUsersChecked);
                  onUserSelectAll(!allUsersChecked);
                }}
              />
            </Col>

            <Col sm={12} md={12} lg={12}>
              <div
                className="show_shared_trivvy_users"
                style={{
                  overflow: "hidden",
                }}
              >
                <div className="shareTableTrivia">
                  {!isMobile && (
                    <LayoutRow className="mobileNoheightActionTable">
                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.user}
                        plainTable
                      >
                        User
                      </LayoutHeading>

                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.date}
                        plainTable
                      >
                        Added On
                      </LayoutHeading>

                      {shareTrivvyViaSMS ? (
                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.phoneNumber}
                          plainTable
                        >
                          Mobile Number
                        </LayoutHeading>
                      ) : null}

                      {shareTrivvyViaEmail ? (
                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.email}
                          plainTable
                        >
                          Email
                        </LayoutHeading>
                      ) : null}

                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.sharedVia}
                        plainTable
                      >
                        Shared Via
                      </LayoutHeading>

                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.action}
                        plainTable
                      >
                        Action
                      </LayoutHeading>
                    </LayoutRow>
                  )}

                  <div
                    style={{
                      maxHeight:
                        sharedWithUsers && sharedWithUsers.length > 0
                          ? "300px"
                          : "0px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      marginLeft: "-15px",
                    }}
                    className="hide-scroll w1scr"
                  >
                    {sharedWithUsers && sharedWithUsers.length > 0
                      ? sharedWithUsers.map((item, itemIndex) => {
                          if (shareTrivvyViaSMS && !item.mobileNumber) {
                            return "";
                          }
                          // new code
                          // const editMode = editingIndex === itemIndex
                          // const showEditBtn = !(item.value || item._id)
                          if (isMobile) {
                            return (
                              <LayoutData
                                fullWidth
                                className="col-pl-0 d-block bg-white"
                              >
                                <div
                                  style={{
                                    alignItems: "center",
                                    display: "flex",
                                  }}
                                  className="my-2 pl-2"
                                >
                                  {isNewUser(item) && (
                                    <Badge
                                      className="messaging_user_new_badge_position"
                                      pill
                                      color="warning"
                                    >
                                      New
                                    </Badge>
                                  )}

                                  <div className="grp_member_profile_image cursor-pointer">
                                    {profilePicValidityCheck(
                                      item.profilePic
                                    ) ? (
                                      <div className="list-item__avatar">
                                        <img src={item.profilePic} />
                                      </div>
                                    ) : (
                                      <span
                                        className="list-item__avatar"
                                        data-letters={
                                          item.value == user.profile._id
                                            ? getInitials(user.profile)
                                            : getInitials(item)
                                        }
                                      ></span>
                                    )}
                                  </div>

                                  <div className="">
                                    <div
                                      className="linkedToolView"
                                      onClick={() => viewMember(item)}
                                    >
                                      {item.value == user.profile._id ? (
                                        "You"
                                      ) : (
                                        <span>
                                          {" "}
                                          {item.firstName}
                                          {item &&
                                          item.lastName &&
                                          item.lastName.length > 0
                                            ? `, ${item.lastName}`
                                            : null}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <Button
                                    onClick={() =>
                                      removeUser(item.value, item.mobileNumber)
                                    }
                                    color="danger"
                                    size="sm"
                                    className="ml-auto mr-3"
                                  >
                                    <BiTrashAlt size={12} />
                                  </Button>
                                </div>
                              </LayoutData>
                            );
                          } else {
                            return (
                              <LayoutRow className="ml-0 mr-0">
                                <LayoutData
                                  colWidth={tableCols.user}
                                  className="bg-white"
                                >
                                  <div
                                    style={{
                                      alignItems: "center",
                                      display: "flex",
                                    }}
                                    className="my-0 pl-2"
                                  >
                                    {isNewUser(item) && (
                                      <Badge
                                        className="messaging_user_new_badge_position"
                                        pill
                                        color="warning"
                                      >
                                        New
                                      </Badge>
                                    )}
                                    <div className="grp_member_profile_image cursor-pointer">
                                      {profilePicValidityCheck(
                                        item.profilePic
                                      ) ? (
                                        <div className="list-item__avatar">
                                          <img src={item.profilePic} />
                                        </div>
                                      ) : (
                                        <span
                                          className="list-item__avatar"
                                          data-letters={
                                            item.value == user.profile._id
                                              ? getInitials(user.profile)
                                              : getInitials(item)
                                          }
                                        ></span>
                                      )}
                                    </div>

                                    <div className="">
                                      <div
                                        className="linkedToolView"
                                        // onClick={() => viewMember(item)}
                                      >
                                        {item.value == user.profile._id ? (
                                          "You"
                                        ) : (
                                          <span>
                                            {" "}
                                            {item.firstName}
                                            {item &&
                                            item.lastName &&
                                            item.lastName.length > 0
                                              ? `, ${item.lastName}`
                                              : null}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </LayoutData>

                                <LayoutData
                                  colWidth={tableCols.date}
                                  className="bg-white addedOnDateCss"
                                >
                                  {moment(item.date).format(
                                    "h:mma on MMM D, YYYY"
                                  )}
                                </LayoutData>

                                {shareTrivvyViaSMS ? (
                                  <LayoutData
                                    colWidth={tableCols.phoneNumber}
                                    className="bg-white"
                                  >
                                    <span>
                                      {item.mobileNumber &&
                                      item.mobileNumber.length > 0
                                        ? item.mobileNumber
                                        : "No"}
                                    </span>
                                  </LayoutData>
                                ) : null}

                                {shareTrivvyViaEmail ? (
                                  <LayoutData
                                    colWidth={tableCols.email}
                                    className="bg-white"
                                  >
                                    <span>{item.email}</span>
                                  </LayoutData>
                                ) : null}

                                <LayoutData
                                  colWidth={tableCols.sharedVia}
                                  className="bg-white"
                                >
                                  {item.shareMediums &&
                                  item.shareMediums.length ? (
                                    <div className="trivvy-share-via-container">
                                      {item.shareMediums.includes("EMAIL") && (
                                        <div>
                                          <BiMailSend
                                            size={"17px"}
                                            style={{
                                              marginRight: "3px",
                                            }}
                                          />
                                          {/* <span className="font-13px">Emailed on {item.emailDate ?moment(item.emailDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                                          <span className="font-13px">
                                            {item.emailDate
                                              ? moment(item.emailDate).format(
                                                  "MM/DD/YYYY"
                                                )
                                              : ""}
                                          </span>
                                        </div>
                                      )}
                                      {item.shareMediums.includes("SMS") && (
                                        <div>
                                          <MdOutlineMobileFriendly
                                            size={"14px"}
                                          />
                                          {/* <span className="font-13px">SMS on {item.smsDate ? moment(item.smsDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                                          <span className="font-13px">
                                            {" "}
                                            {item.smsDate
                                              ? moment(item.smsDate).format(
                                                  "MM/DD/YYYY"
                                                )
                                              : ""}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </LayoutData>

                                <LayoutData
                                  colWidth={tableCols.action}
                                  className="bg-white"
                                >
                                  <div className="d-flex">
                                    <Button
                                      onClick={() =>
                                        removeUser(
                                          item.value,
                                          item.mobileNumber
                                        )
                                      }
                                      color="danger"
                                      size="sm"
                                      style={{
                                        width: "40px",
                                      }}
                                    >
                                      <BiTrashAlt size={12} />
                                    </Button>
                                  </div>
                                </LayoutData>
                              </LayoutRow>
                            );
                          }

                          // old code
                          // if (isMobile) {
                          //   return (
                          //     <LayoutData
                          //       fullWidth
                          //       className="col-pl-0 d-block bg-white">
                          //       <div
                          //         style={{
                          //           alignItems: 'center',
                          //           display: 'flex',
                          //         }}
                          //         className="my-2 pl-2">
                          //         <div className="grp_member_profile_image cursor-pointer">
                          //           {profilePicValidityCheck(
                          //             item.profilePic
                          //           ) ? (
                          //             <div className="list-item__avatar">
                          //               <img src={item.profilePic} />
                          //             </div>
                          //           ) : (
                          //             <span
                          //               className="list-item__avatar"
                          //               data-letters={
                          //                 item.value == user.profile._id
                          //                   ? getInitials(user.profile)
                          //                   : getInitials(item)
                          //               }></span>
                          //           )}

                          //           {/* {item.isSubmitted && (
                          //             <Badge pill color="success">
                          //               Submitted
                          //             </Badge>
                          //           )} */}
                          //         </div>

                          //         <div className="">
                          //           <div
                          //             className="linkedToolView"
                          //             onClick={() => viewMember(item)}>
                          //             {item.value == user.profile._id ? (
                          //               'You'
                          //             ) : (
                          //               <span>
                          //                 {' '}
                          //                 {item && item.firstName}
                          //                 {item &&
                          //                 item.lastName &&
                          //                 item.lastName.length > 0
                          //                   ? `, ${item.lastName}`
                          //                   : null}
                          //                 {!item.firstName && !item.lastName
                          //                   ? item.email
                          //                   : ''}
                          //               </span>
                          //             )}
                          //           </div>
                          //         </div>

                          //         <Button
                          //           onClick={() =>
                          //             removeUser(item.value, item.mobileNumber)
                          //           }
                          //           color="danger"
                          //           size="sm"
                          //           className="ml-auto mr-3">
                          //           <BiTrashAlt size={12} />
                          //         </Button>
                          //       </div>
                          //     </LayoutData>
                          //   )
                          // } else {
                          //   return (
                          //     <LayoutRow className="ml-0 mr-0">
                          //       <LayoutData
                          //         colWidth={tableCols.user}
                          //         className="bg-white">
                          //         <div
                          //           style={{
                          //             alignItems: 'center',
                          //             display: 'flex',
                          //           }}
                          //           className="my-0 pl-2">
                          //           <div className="grp_member_profile_image cursor-pointer">
                          //             {profilePicValidityCheck(
                          //               item.profilePic
                          //             ) ? (
                          //               <div className="list-item__avatar">
                          //                 <img src={item.profilePic} />
                          //               </div>
                          //             ) : (
                          //               <span
                          //                 className="list-item__avatar"
                          //                 data-letters={
                          //                   item.value == user.profile._id
                          //                     ? getInitials(user.profile)
                          //                     : getInitials(item)
                          //                 }></span>
                          //             )}
                          //           </div>

                          //           <div className="">
                          //             <div
                          //               className="linkedToolView"
                          //               onClick={() => viewMember(item)}>
                          //               {item.value == user.profile._id ? (
                          //                 'You'
                          //               ) : (
                          //                 <span>
                          //                   {' '}
                          //                   {item.firstName}
                          //                   {item &&
                          //                   item.lastName &&
                          //                   item.lastName.length > 0
                          //                     ? `, ${item.lastName}`
                          //                     : null}
                          //                   {!item.firstName && !item.lastName
                          //                     ? item.email
                          //                     : ''}
                          //                 </span>
                          //               )}
                          //             </div>
                          //           </div>
                          //         </div>
                          //         {/* {item.isSubmitted && (
                          //           <Badge pill color="success">
                          //             Submitted
                          //           </Badge>
                          //         )} */}
                          //       </LayoutData>

                          //       <LayoutData
                          //         colWidth={tableCols.date}
                          //         className="bg-white addedOnDateCss">
                          //         {moment(item.date).format(
                          //           'h:mma on MMM D, YYYY'
                          //         )}
                          //       </LayoutData>
                          //       {shareTrivvyViaSMS ? (
                          //         <LayoutData
                          //           colWidth={tableCols.phoneNumber}
                          //           className="bg-white">
                          //           {item.mobileNumber &&
                          //           item.mobileNumber.length > 0
                          //             ? item.mobileNumber
                          //             : 'No'}
                          //         </LayoutData>
                          //       ) : null}

                          //       <LayoutData
                          //         colWidth={tableCols.sharedVia}
                          //         className="bg-white">
                          //         {item.shareMediums &&
                          //         item.shareMediums.length ? (
                          //           <div className="trivvy-share-via-container">
                          //             {item.shareMediums.includes('EMAIL') && (
                          //               <div>
                          //                 <BiMailSend
                          //                   size={'17px'}
                          //                   style={{
                          //                     marginRight: '3px',
                          //                   }}
                          //                 />
                          //                 {/* <span className="font-13px">Emailed on {item.emailDate ?moment(item.emailDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                          //                 <span className="font-13px">
                          //                   {item.emailDate
                          //                     ? moment(item.emailDate).format(
                          //                         'MM/DD/YYYY'
                          //                       )
                          //                     : ''}
                          //                 </span>
                          //               </div>
                          //             )}
                          //             {item.shareMediums.includes('SMS') && (
                          //               <div>
                          //                 <MdOutlineMobileFriendly
                          //                   size={'14px'}
                          //                 />
                          //                 {/* <span className="font-13px">SMS on {item.smsDate ? moment(item.smsDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                          //                 <span className="font-13px">
                          //                   {' '}
                          //                   {item.smsDate
                          //                     ? moment(item.smsDate).format(
                          //                         'MM/DD/YYYY'
                          //                       )
                          //                     : ''}
                          //                 </span>
                          //               </div>
                          //             )}
                          //           </div>
                          //         ) : (
                          //           ''
                          //         )}
                          //       </LayoutData>

                          //       <LayoutData
                          //         colWidth={tableCols.action}
                          //         className="bg-white">
                          //         <Button
                          //           onClick={() =>
                          //             removeUser(item.value, item.mobileNumber)
                          //           }
                          //           color="danger"
                          //           size="sm"
                          //           style={{
                          //             width: '40px',
                          //           }}>
                          //           <BiTrashAlt size={12} />
                          //         </Button>
                          //       </LayoutData>
                          //     </LayoutRow>
                          //   )
                          // }
                        })
                      : ""}
                  </div>

                  {/* new code */}
                  {!usersLoading ? (
                    <Row className="mr-0 px-0">
                      <ActionLayoutData
                        noDefault
                        className="col-pl-0 bg-white"
                        colWidth={12}
                      >
                        {options.length > 0 ? (
                          <Select
                            name="user-select"
                            placeholder={
                              "Start typing users name to add new..."
                            }
                            isOpen={true}
                            options={
                              usersList
                                .filter((x) =>
                                  shareTrivvyViaSMS ? x.mobileNumber : x.email
                                ) // First, filter users with a mobileNumber
                                .filter(
                                  (x) =>
                                    !sharedWithUsers.some(
                                      (y) => y.value == x.value
                                    )
                                ) // Then, filter out users already shared
                            }
                            onChange={(itm) => onUserSelect(itm)}
                            onInputChange={handleInputChange}
                            className={`trivia-user-share-select-row ${
                              isMobile ? "" : "py-2"
                            }`}
                            classNamePrefix="select"
                            open={true}
                          />
                        ) : (
                          <LayoutRow className="ml-0 mr-0 no-borders-input-row">
                            <LayoutData
                              noDefault
                              className="col-pl-0 bg-white"
                              colWidth={3}
                            >
                              <div className="d-flex align-items-center">
                                <Input
                                  autoFocus
                                  value={newUser.name}
                                  ref={innerRef}
                                  placeholder="Start typing users name to add new..."
                                  onChange={(e) => {
                                    handleNewUserRowChange(
                                      e.target.value,
                                      "name",
                                      0
                                    );
                                  }}
                                />
                                {isNewUser(newUser) ? (
                                  <Badge pill color="warning">
                                    New
                                  </Badge>
                                ) : (
                                  ""
                                )}
                              </div>
                            </LayoutData>

                            <LayoutData colWidth={2}>-</LayoutData>

                            {shareTrivvyViaSMS && (
                              <LayoutData
                                noDefault
                                className="col-pl-0 bg-white py-0"
                                colWidth={3}
                              >
                                <PhoneInputWithCountrySelect
                                  ref={innerRef2}
                                  placeholder="Enter phone number"
                                  value={newUser.mobileNumber}
                                  onChange={(v) => {
                                    handleNewUserRowChange(
                                      formatPhoneNumber(v),
                                      "mobileNumber",
                                      0
                                    );
                                  }}
                                  style={{
                                    height: "40px",
                                  }}
                                  defaultCountry="US"
                                />
                              </LayoutData>
                            )}

                            {shareTrivvyViaEmail && (
                              <LayoutData
                                noDefault
                                className="col-pl-0 bg-white py-0"
                                colWidth={3}
                              >
                                <Input
                                  value={newUser.email}
                                  onChange={(e) => {
                                    handleNewUserRowChange(
                                      e.target.value,
                                      "email",
                                      0
                                    );
                                  }}
                                />
                              </LayoutData>
                            )}

                            <LayoutData colWidth={2}>-</LayoutData>

                            <LayoutData
                              noDefault
                              className="col-pl-0 bg-white"
                              colWidth={2}
                            >
                              <div className="d-flex">
                                <Button
                                  onClick={() => addNewRowUserToShareTable(0)}
                                  className="mx-1 px-2"
                                  color="success"
                                  style={{ width: "35px" }}
                                  disabled={!newUser.mobileNumber && !newUser.email}
                                >
                                  <BiPlusCircle size={20} />
                                </Button>
                                <Button
                                  onClick={() => revertOptions()}
                                  className="mx-1 px-2"
                                  color="danger"
                                  style={{ width: "35px" }}
                                >
                                  <BiXCircle size={20} />
                                </Button>
                              </div>
                            </LayoutData>
                          </LayoutRow>
                        )}
                      </ActionLayoutData>
                    </Row>
                  ) : (
                    <div className="text-center">Loading...</div>
                  )}

                  {/* old code */}
                  {/* <Row className="mr-0 px-0">
                    <ActionLayoutData
                      noDefault
                      className="col-pl-0 bg-white"
                      colWidth={12}>
                      {options.length > 0 ? (
                        // <Async
                        //   name="user-select"
                        //   placeholder={'Start typing users name to add new...'}
                        //   loadOptions={getOptions}
                        //   filterOptions={(options, filter, currentValues) => {
                        //     // Do no filtering, just return all options
                        //     return options
                        //   }}
                        //   onChange={(itm) => onUserSelect(itm)}
                        //   className={`trivia-user-share-select-row ${
                        //     isMobile ? '' : 'py-2'
                        //   }`}
                        //   classNamePrefix="select"
                        // />
                        <Select
                          name="user-select"
                          placeholder={'Start typing users name to add new...'}
                          isOpen={true}
                          options={usersList.filter(
                            (x) =>
                              !sharedWithUsers.some((y) => y.value == x.value)
                          )}
                          onChange={(itm) => onUserSelect(itm)}
                          onInputChange={handleInputChange}
                          className={`trivia-user-share-select-row ${
                            isMobile ? '' : 'py-2'
                          }`}
                          classNamePrefix="select"
                          open={true}
                        />
                      ) : (
                        <LayoutRow className="ml-0 mr-0 no-borders-input-row">
                          <LayoutData
                            noDefault
                            className="col-pl-0 bg-white"
                            colWidth={3}>
                            <div className="d-flex align-items-center">
                              <Input
                                autoFocus
                                value={newUser.name}
                                ref={innerRef}
                                placeholder="Start typing users name to add new..."
                                onChange={(e) => {
                                  handleNewUserRowChange(
                                    e.target.value,
                                    'name',
                                    0
                                  )
                                }}
                              />
                              {isNewUser(newUser) ? (
                                <Badge pill color="warning">
                                  New
                                </Badge>
                              ) : (
                                ''
                              )}
                            </div>
                          </LayoutData>
                          <LayoutData colWidth={2}>-</LayoutData>
                          <LayoutData
                            noDefault
                            className="col-pl-0 bg-white py-0"
                            colWidth={3}>
                            <PhoneInputWithCountrySelect
                              ref={innerRef2}
                              placeholder="Enter phone number"
                              value={newUser.mobileNumber}
                              onChange={(v) => {
                                handleNewUserRowChange(
                                  formatPhoneNumber(v),
                                  'mobileNumber',
                                  0
                                )
                              }}
                              style={{
                                height: '40px',
                              }}
                              defaultCountry="US"
                            />
                          </LayoutData>
                          <LayoutData colWidth={2}>-</LayoutData>
                          <LayoutData
                            noDefault
                            className="col-pl-0 bg-white"
                            colWidth={2}>
                            <div className="d-flex">
                              <Button
                                onClick={() => addNewRowUserToShareTable(0)}
                                className="mx-1 px-2"
                                color="success"
                                style={{ width: '35px' }}
                                disabled={!newUser.mobileNumber}>
                                <BiPlusCircle size={20} />
                              </Button>
                              <Button
                                onClick={() => revertOptions()}
                                className="mx-1 px-2"
                                color="danger"
                                style={{ width: '35px' }}>
                                <BiXCircle size={20} />
                              </Button>
                            </div>
                          </LayoutData>
                        </LayoutRow>
                        // <div>Add new user</div>
                      )}
                    </ActionLayoutData>
                  </Row> */}
                </div>
              </div>
            </Col>
          </FormGroup>
        </div>
      </div>

      {usersChanged() ? (
        <Alert className="mt-4 mb-0" color="info">
          For changes to take effect, please click on the{" "}
          <strong>Save invited users</strong> button below.
        </Alert>
      ) : null}

      {survey && (
        <Button
          className="trivia-action-button-main-reverse share-via-trivvy-button mt-3 mb-4"
          disabled={saveSharedConfig()}
          onClick={saveTrivvyShareUsersApi}
        >
          Save invited users
        </Button>
      )}

      {usersChanged() || triviaShareAndPrivacy.privacy != survey.privacy ? (
        <Button
          className="trivia-action-button-main undo-button share-via-trivvy-button ml-4 mt-3 mb-4"
          onClick={() => {
            setTriviaShareAndPrivacy({
              privacy: survey.privacy,
              sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
            });
          }}
        >
          Undo Changes
        </Button>
      ) : null}
    </div>
  );

  return (
    <div className="trivia_share_page">
      {shareTeamsopen && (
        <TeamsSharePopup
          handleSocialShare={handleSocialShare}
          teamsShared={[]}
          answer={""}
          orgId={user.profile.organizationId._id}
          userId={user.profile._id}
          setShowTeamsPopup={(val) => setShareTeamsOpen(val)}
          organization={user.profile.organizationId}
        />
      )}

      <div
        style={{
          display: "none",
        }}
      >
        <QRCodeCanvas
          id="qrcode-canvas"
          level="H"
          size={100}
          value={shareUrl + "?medium=qrcode"}
        />
      </div>

      {shareSlackopen && (
        <SlackSharePopup
          handleSocialShare={handleSocialShare}
          slackShared={[]}
          answer={""}
          orgId={user.profile.organizationId._id}
          userId={user.profile._id}
          setShowSlackPopup={(val) => setShareSlackOpen(val)}
          organization={user.profile.organizationId}
        />
      )}
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Col sm={9} className="">
          {!survey.isMessaging && (
            <Card className="pt-4 px-4 sharepage_top_card">
              <div
                className="d-flex"
                style={{
                  ...(isMobile && {
                    flexDirection: "column",
                    gap: "15px",
                  }),
                }}
              >
                <div
                  style={{ width: isMobile ? "100%" : "15%" }}
                  className="text-center"
                >
                  <Button
                    // disabled={publishDisabled(survey) || adminRestricted}
                    onClick={(e) => {
                      const callBackCode = () => {};
                      publishTriviaApiCall(!survey.isPublished, callBackCode);
                      if (survey.isPublished) {
                        props.showPublishToast();
                      }
                    }}
                    className="share_page_btn_color w-100"
                  >
                    {survey.isPublished ? (
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-send-slash-fill"
                          viewBox="0 0 16 16"
                          style={{ position: "relative" }}
                        >
                          <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
                          <path d="M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95m-4.243.707a2.5 2.5 0 0 1 3.147-.318l-3.465 3.465a2.5 2.5 0 0 1 .318-3.147m.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z" />
                        </svg>{" "}
                        Unpublish
                      </span>
                    ) : (
                      <span>
                        <PiPaperPlaneRightFill />
                        Publish
                      </span>
                    )}
                  </Button>
                </div>

                <div
                  style={{
                    width: isMobile ? "100%" : "70%",
                    padding: isMobile ? 0 : "0 2rem",
                    position: "relative",
                  }}
                >
                  <Input
                    type="text"
                    value={shareUrl + "?medium=copy"}
                    disabled
                    style={{ width: isMobile ? "100%" : "90%" }}
                  />

                  <Button
                    disabled={!isSharable}
                    onClick={copySurveyUrl}
                    className={
                      !isMobile
                        ? `share_page_copy_link_btn_pos copy_link_btn_border share_page_btn_color ${
                            isCopied ? "success" : ""
                          }`
                        : `share_page_btn_color share_page_copy_link_btn_pos_mobile copy_link_btn_border ${
                            isCopied ? "success" : ""
                          }`
                    }
                  >
                    {isCopied ? (
                      <span>
                        {" "}
                        Copied <BiCheck />{" "}
                      </span>
                    ) : (
                      "Copy Link"
                    )}
                  </Button>
                </div>

                <div
                  style={{ width: isMobile ? "100%" : "15%" }}
                  className="text-center"
                >
                  <Button
                    outline
                    className="share_page_btn_qr_code w-100"
                    onClick={downloadQRCode}
                    disabled={!isSharable}
                  >
                    Get QR Code <MdUpload color="#F4A522" />
                  </Button>
                </div>
              </div>

              <div className="">
                <Row className={`mt-3 share-quiz-privacy`}>
                  <Col md={6} sm={12} lg={6} xs={12}>
                    <div className="row text-left my-3">
                      <div className="col-md-5 col-lg-5 text-left">
                        <h5>Sharing Permissions:</h5>
                      </div>
                      <div className="col-md-7 col-lg-7 enterprise-settings-value">
                        <Select
                          className="pt-0"
                          value={privacy === "ENTERPRISE" ? "CUSTOM" : privacy}
                          onChange={(val) => {
                            console.log("val --- ", val);
                            setTriviaShareAndPrivacy({
                              ...triviaShareAndPrivacy,
                              privacy: val.value,
                            });
                          }}
                          options={TRIVIA_SHARE_PRIVACY_OPTIONS}
                          placeholder="Select Privacy"
                          disabled={!isSharable}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={6} sm={12} lg={6} xs={12}>
                    {privacy == "PUBLIC" && (
                      <div
                        data-tip={
                          planInvalid
                            ? "Upgrade your plan to Premium or above to enable this feature"
                            : ""
                        }
                      >
                        <div className="row text-left my-3">
                          <div className="col-md-5 col-lg-5 text-left">
                            <h5>User must provide:</h5>
                          </div>
                          <div className="col-md-7 col-lg-7 enterprise-settings-value">
                            <Select
                              className="pt-0"
                              value={userIdentification}
                              onChange={(val) => {
                                setUserIdentification(val.value);
                                callApiToAutoSave("userIdentificationOptions", [
                                  val.value,
                                ]);
                                setCurrentTrivia({
                                  ...survey,
                                  userIdentificationOptions: [val.value],
                                });
                              }}
                              options={TRIVIA_USER_IDENTIFICATION_OPTIONS}
                              placeholder="Select User Identification"
                              disabled={planInvalid}
                            />{" "}
                          </div>
                        </div>

                        <ReactTooltip />
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </Card>
          )}

          {isEndDateBeforeToday ? (
            <Alert className="mt-4" color="primary">
              <b>
                The end date needs to be updated before sharing this trivvy.
              </b>
            </Alert>
          ) : (
            ""
          )}

          {survey.isMessaging ? (
            tableUI
          ) : (
            <div
              className={`my-4 ${
                isMobile
                  ? "sharepage_item_cards_parent_div_mobile"
                  : "sharepage_item_cards_parent_div"
              }`}
            >
              <div
                className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
                onClick={() => {
                  setShareTrivvyViaEmail(true);
                  setShareTrivvyViaSMS(false);
                  setEmailSmsSendModal({
                    open: true,
                    type: "EMAIL_LINK",
                  });
                }}
              >
                <div className="share_page_card_heading">
                  <BiMailSend className="logo-icon" /> Send by Email
                </div>
                <div className="share_page_card_description">
                  Share the survey directly with your audience via email. Simply
                  add email addresses and send with a click.
                </div>
              </div>

              <div
                className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
                onClick={() => {
                  setShareTrivvyViaEmail(false);
                  setShareTrivvyViaSMS(true);
                  setEmailSmsSendModal({
                    open: true,
                    type: "SMS_TRIVVY",
                  });
                }}
              >
                <div className="share_page_card_heading">
                  <BiMobileVibration className="logo-icon" /> Send survey as
                  Text
                </div>
                <div className="share_page_card_description">
                  Embed the survey questions directly into a text message for
                  quick and seamless responses.
                </div>
              </div>

              <div
                className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
                onClick={() => {
                  setShareTrivvyViaEmail(false);
                  setShareTrivvyViaSMS(true);
                  setEmailSmsSendModal({
                    open: true,
                    type: "TEXT_LINK",
                  });
                }}
              >
                <div className="share_page_card_heading">
                  <MdOutlineMobileFriendly className="logo-icon" /> Send Link by
                  Text
                </div>
                <div className="share_page_card_description">
                  Deliver the survey link instantly via text messages. Reach
                  your audience on their mobile devices.
                </div>
              </div>

              <div
                className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
                onClick={() => {
                  if (isSharable)
                    window.open(
                      `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
                        shareUrl + "?medium=linkedin"
                      )}`
                    );
                }}
              >
                <div className="share_page_card_heading">
                  <FaLinkedin className="logo-icon" /> LinkedIn
                </div>
                <div className="share_page_card_description">
                  Share the survey with your professional network on LinkedIn.
                  Engage with peers and industry contacts.
                </div>
              </div>

              <div
                className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
                onClick={() => {
                  if (isSharable)
                    window.open(
                      `https://wa.me/?text=${encodeURIComponent(
                        shareUrl + "?medium=whatsapp"
                      )}`
                    );
                }}
              >
                <div className="share_page_card_heading">
                  <FaWhatsapp className="logo-icon" /> Whatsapp
                </div>
                <div className="share_page_card_description">
                  Send the survey link to individuals or groups on WhatsApp.
                  Perfect for quick and personal sharing.
                </div>
              </div>

              <div
                className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
                onClick={() => setShareSlackOpen(true)}
              >
                <div className="share_page_card_heading">
                  <FaSlack className="logo-icon" /> Slack
                </div>
                <div className="share_page_card_description">
                  Share the survey within your workspace on Slack. Collaborate
                  and collect responses from your team.
                </div>
              </div>
            </div>
          )}

          <Modal isOpen={emailSmsSendModal.open}>
            <ModalHeader
              toggle={() => setEmailSmsSendModal({ open: false, type: "" })}
            >
              {emailSmsSendModal.type == "EMAIL_LINK"
                ? "Send email"
                : "Send Text"}
            </ModalHeader>
            <ModalBody className="pb-4">
              {showNoChangeAlert() &&
                triviaShareAndPrivacy.sharedWithUsers.length > 0 && (
                  <Alert color="info" className="mt-5">
                    All invited users have already received an email and/or SMS
                    text. To share trivvy, please invite more users.
                  </Alert>
                )}

              <div className="mt-3">
                <Alert color="info">
                  <b>Suggestion:</b> {OVERTIME_TEXT}
                </Alert>
              </div>

              {tableUI}

              {showLimitSMSAlert && showLimitSMSAlert.display ? (
                <Alert style={{ backgroundColor: "rgb(212 233 237 / 75%)" }}>
                  {showLimitSMSAlert.remainingLimit ? (
                    <span>
                      You have only {showLimitSMSAlert.remainingLimit} SMS left
                      and you are sending {showLimitSMSAlert.totalSMS} SMS, So
                      only first {showLimitSMSAlert.remainingLimit} will recieve
                      SMS notifications. Do you want to continue?
                    </span>
                  ) : (
                    <span>
                      You have only {showLimitSMSAlert.remainingLimit} SMS left
                      and you are sending {showLimitSMSAlert.totalSMS} SMS, So
                      no one will recieve SMS notifications. Do you want to
                      continue?
                    </span>
                  )}

                  <div className="mt-3">
                    <Button
                      color="success"
                      onClick={() => {
                        setAllowSendLimitSMS(true);
                      }}
                    >
                      Continue
                    </Button>{" "}
                    <Button
                      onClick={() => {
                        setShowLimitSMSAlert({
                          display: false,
                          remainingLimit: 0,
                          totalSMS: 0,
                        });
                      }}
                      className="ml-3"
                      color="danger"
                    >
                      Cancel
                    </Button>
                  </div>
                </Alert>
              ) : (
                ""
              )}
              {emailSmsSendModal.type == "SMS_TRIVVY" ? (
                <SendSmsTextQuestionsModal trivia={survey} editCurrentTriviaShareData={editCurrentTriviaShareData} usersChanged={usersChanged} />
              ) : (
                <div>
                  <div>
                    {showShareconfirm.display ? (
                      <Alert>
                        <div>
                          Are you sure you want to share this trivvy with the
                          user(s)?
                          <br />
                          {showShareconfirm.emails > 0 ||
                          showShareconfirm.sms > 0
                            ? "This will send"
                            : ""}
                          {showShareconfirm.emails > 0 ? (
                            <b>
                              {" "}
                              {showShareconfirm.emails}{" "}
                              {showShareconfirm.emails == 1
                                ? "Email"
                                : "Emails"}{" "}
                            </b>
                          ) : (
                            ""
                          )}
                          {showShareconfirm.sms > 0 ? (
                            <b> {showShareconfirm.sms} Sms </b>
                          ) : (
                            ""
                          )}
                          {showShareconfirm.emails > 0 ||
                          showShareconfirm.sms > 0
                            ? "."
                            : ""}
                        </div>

                        <div className="mt-2">
                          <Button
                            color="success"
                            size="sm"
                            onClick={() => {
                              handleClickShareButton(true);
                              setShowShareConfirm({
                                display: false,
                                sms: 0,
                                emails: 0,
                              });
                            }}
                          >
                            Ok
                          </Button>

                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => {
                              setShowShareConfirm({
                                display: false,
                                sms: 0,
                                emails: 0,
                              });
                            }}
                            className="ml-3"
                          >
                            Cancel
                          </Button>
                        </div>
                      </Alert>
                    ) : (
                      <div>
                        {!survey.isMessaging && (
                          <Button
                            disabled={
                              !isSharable ||
                              showNoChangeAlert() ||
                              (triviaShareAndPrivacy.privacy === "CUSTOM" &&
                                triviaShareAndPrivacy.sharedWithUsers.length ==
                                  0) ||
                              (!shareTrivvyViaEmail && !shareTrivvyViaSMS)
                            }
                            onClick={() => handleClickShareButton(false)}
                            className="share-via-trivvy-button trivia-action-button-main mr-2 mt-2"
                          >
                            {isMobile
                              ? "Share trivvy link"
                              : "Share trivvy link"}
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </ModalBody>
          </Modal>
        </Col>
      </Row>
    </div>
  );
}
